import { Box, Button, styled } from '@mui/material';
import React from 'react';

interface ActionButtonsStrategyFooterProps {
  onClose: () => void;
  status: string;
  revertHidden: boolean;
  approveHidden: boolean;
  handleRevert: () => void;
  handleApprove: (id: any) => void;
  id: any;
  cancelButtonText?: string;
  revertButtonText?: string;
  approveButtonText?: string;
  cancelButtonColor?: string;
  revertButtonColor?: string;
  approveButtonColor?: string;
}

const TextAreaStyled = styled('textarea')(({ backgroundColor }: { backgroundColor: string }) => ({
  backgroundColor: backgroundColor || 'white',
  width: '100%',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginRight: '15px',
  resize: 'vertical',
}));

const ActionButtonsStrategyFooter: React.FC<ActionButtonsStrategyFooterProps> = ({
  // onClose,
  status,
  revertHidden,
  approveHidden,
  handleRevert,
  handleApprove,
  id,
  // cancelButtonText = 'Cancel',
  revertButtonText = 'Revert',
  approveButtonText = 'Approve',
  // cancelButtonColor = '#000',
  revertButtonColor = '#D90000',
  approveButtonColor = '#058B2B',
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        <Box
          sx={{ display: 'flex', gap: '20px', justifyContent: 'end', marginRight: '20px', marginTop: '20px' }}
        >
          {(status !== 'Reverted') && (
            <>
              {!revertHidden && (
                <>
                  <Button
                    variant="outlined"
                    sx={{
                      color: revertButtonColor,
                      padding: '7px 35px',
                      textTransform: 'none',
                      border: `1px solid ${revertButtonColor}`,
                    }}
                    onClick={handleRevert}
                  >
                    {revertButtonText}
                  </Button>
                </>
              )}

              {!approveHidden && status !== 'Approved' && (
                <Button
                  variant="contained"
                  sx={{
                    color: '#fff',
                    padding: '7px 35px',
                    textTransform: 'none',
                    bgcolor: approveButtonColor,
                  }}
                  onClick={() => handleApprove(id)}
                >
                  {approveButtonText}
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
      <TextAreaStyled
        placeholder="Enter the Reason"
        value=""
        backgroundColor={'white'}
        sx={{mt: 2}}
      />
    </>
  );
};

export default ActionButtonsStrategyFooter;